// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';

import * as analytics from 'analytics/Analytics';
import {Sequence} from 'components/Sequence';
import DataConnector from 'connect/DataConnector';
import {HR_TEMPLATE_TAB_ID} from 'constants/CRISPRConstants';
import {GenomeEngineeringPanelState, SequenceFileState} from 'FileStates';
import {getInitialFolderIdForDuplicate} from 'molbio/components/getInitialFolderIdForDuplicate';
// @ts-expect-error
import CRISPRAnalysisActions from 'molbio/crispr/CRISPRAnalysisActions';
import CRISPRAnalysisStore from 'molbio/crispr/CRISPRAnalysisStore';
import CRISPRAnalysisTabState from 'molbio/crispr/CRISPRAnalysisTabState';
import {openCRISPRModal} from 'molbio/crispr/CRISPRModal';
import HRTemplateActions from 'molbio/crispr/hr-template/HRTemplateActions';
import HRTemplateModal from 'molbio/crispr/hr-template/HRTemplateModal';
import HRTemplateStore from 'molbio/crispr/hr-template/HRTemplateStore';
import HRTemplateTabState from 'molbio/crispr/hr-template/HRTemplateTabState';
import ToolbarSignupMessage from 'nav/share/growth/ToolbarSignupMessage';
import {showValueMessagingForSharedFile} from 'nav/share/growth/Util';
import EntityStore from 'stores/EntityStore';
import getTestProps from 'test/lib/cypress/getTestProps';
import ReactPanelBaseView, {getTabAndPanelIds, Subpanel} from 'toolbar/ReactPanelBaseView';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import * as ModalContainer from 'ui-library/ModalContainer';
import Spinner from 'ui-library/Spinner';
import * as DateUtil from 'util/DateUtil';

function redirectToSignUp(): void {
  window.location.href = '/signup';
}

class CRISPRPanelViewConnector extends DataConnector<Props, EnhancedProps> {
  override shouldSubscribeToRedux = false;
  override stores = [CRISPRAnalysisStore, HRTemplateStore];

  enhanceProps(): EnhancedProps {
    return {
      analyses: this.crisprAnalysisStore().getAnalysesForSequence(this.props.sequenceId),
      analysisLoading: this.crisprAnalysisStore().getState().analysisLoading,
      hrTemplateDesignState: this.hrTemplateStore().getDesignState(this.props.sequenceId),
    };
  }
}

interface Props {
  allowEdits: boolean;
  sequenceId: string;
  openAnalysis: (analysisId: unknown) => void;
  closeAnalysis: (analysisId: unknown) => void;
  createHRTemplate: () => void;
  openHRTemplate: () => void;
  closePanel: () => void;
}

interface EnhancedProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  analyses: Array<any>;
  analysisLoading: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hrTemplateDesignState?: any;
}

class CRISPRPanelView extends React.Component<Props & EnhancedProps> {
  isHRTemplateLoading = (): boolean =>
    (this.props.hrTemplateDesignState != null
      ? this.props.hrTemplateDesignState.isHRTemplateLoading
      : undefined) || false;

  allowHRTemplateEdits = (): boolean =>
    this.props.allowEdits ||
    __guard__(
      this.props.hrTemplateDesignState != null ? this.props.hrTemplateDesignState.sequence : undefined,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (x: any) => x.allowResidueEdits({tabId: HR_TEMPLATE_TAB_ID})
    ) ||
    false;

  override componentDidMount(): void {
    CRISPRAnalysisActions.fetchForSequence(this.props.sequenceId);
    HRTemplateActions.fetchForSequence(this.props.sequenceId);
  }

  deleteAnalysis = (analysisId: string, e: JQueryEventObject): void => {
    e.stopPropagation();
    this.props.closeAnalysis(analysisId);
    CRISPRAnalysisActions.delete(analysisId);
  };

  _openCRISPRModal = (): void => {
    openCRISPRModal({sequenceId: this.props.sequenceId});
    this.props.closePanel();
  };

  override render(): JSX.Element {
    const signedIn = EntityStore.currentUser() != null;
    return (
      <div
        aria-labelledby="genome-engineering-tab"
        className="u-small-spacing-top"
        id="genome-engineering-panel"
        role="tabpanel"
        {...getTestProps({component: 'CRISPRPanel', element: 'root'})}
      >
        {signedIn ? (
          <Button
            buttonStyle={ButtonStyle.PRIMARY}
            size={ButtonSize.SMALL}
            fullWidth={true}
            text={
              this.props.allowEdits ? 'Design and analyze guides' : 'Guide design disabled when read-only'
            }
            onClick={this._openCRISPRModal}
            disabled={!this.props.allowEdits}
            dataTestAttrs={{component: 'CRISPRPanel', element: 'guideDesignButton'}}
          />
        ) : showValueMessagingForSharedFile() ? (
          <ToolbarSignupMessage action="create a guide" />
        ) : (
          <Button
            buttonStyle={ButtonStyle.PRIMARY}
            fullWidth={true}
            size={ButtonSize.SMALL}
            text="Sign up to design guides"
            onClick={redirectToSignUp}
          />
        )}
        <Row>
          <Col sm={12}>
            <h5 className="u-spacing-top">Saved guide analyses</h5>
            {this.props.analyses != null && this.props.analyses.length > 0 ? (
              <table
                className="table table-striped table-condensed table-hover"
                {...getTestProps({component: 'CRISPRPanelView', element: 'savedGuideAnalysesTable'})}
              >
                <tbody>
                  {Array.from(this.props.analyses).map((analysis) => (
                    <tr
                      className="panel-library-row"
                      onClick={this.props.openAnalysis.bind(null, analysis.id)}
                      key={analysis.id}
                    >
                      <td>{analysis.name}</td>
                      <td>
                        {this.props.allowEdits ? (
                          <span
                            className="glyphicon glyphicon-trash delete pull-right"
                            onClick={this.deleteAnalysis.bind(null, analysis.id)}
                          />
                        ) : null}
                        {DateUtil.readableTime(analysis.modifiedAt)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : this.props.analysisLoading ? (
              <>
                <div className="loading-spinner-background u-small-padding">
                  <Spinner />
                </div>
              </>
            ) : (
              <span>No guide analyses</span>
            )}
          </Col>
        </Row>
        {!showValueMessagingForSharedFile() && (
          <div className="u-spacing-top">
            <div className="panel-divider" />
            {signedIn ? (
              <Button
                buttonStyle={ButtonStyle.PRIMARY}
                fullWidth={true}
                size={ButtonSize.SMALL}
                text={
                  this.allowHRTemplateEdits()
                    ? this.isHRTemplateLoading()
                      ? 'Loading...'
                      : HRTemplateStore.containsDesign(this.props.sequenceId)
                        ? 'Open HR template design'
                        : 'Design HR template (ssODN)'
                    : 'HR template design disabled when read-only'
                }
                onClick={() => {
                  if (HRTemplateStore.containsDesign(this.props.sequenceId)) {
                    this.props.openHRTemplate();
                  } else {
                    this.props.createHRTemplate();
                  }
                }}
                disabled={!this.allowHRTemplateEdits() || this.isHRTemplateLoading()}
              />
            ) : (
              <Button
                buttonStyle={ButtonStyle.PRIMARY}
                fullWidth={true}
                size={ButtonSize.SMALL}
                text="Sign up to design HR template"
                onClick={redirectToSignUp}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

const ConnectedCRISPRPanelView = CRISPRPanelViewConnector.connect(CRISPRPanelView);

class GenomeEngineeringPanelView extends ReactPanelBaseView<GenomeEngineeringPanelState, Sequence> {
  getSubpanels = (): Array<Subpanel> => [
    {
      title: 'CRISPR',
      ...getTabAndPanelIds('genome-engineering'),
      component: (
        <ConnectedCRISPRPanelView
          allowEdits={this.model.allowFeatureEdits()}
          sequenceId={this.model.id}
          openAnalysis={this.openAnalysis}
          closeAnalysis={this.closeAnalysis}
          closePanel={this.closePanel}
          createHRTemplate={() => {
            // Open a modal to allow the user to create an HRTemplateDesign.
            this.closePanel();
            analytics.track('hr_template', 'open_modal_from_genome_panel');
            ModalContainer.open(
              HRTemplateModal,
              <HRTemplateModal
                onRequestClose={() => {
                  ModalContainer.close(HRTemplateModal);
                }}
                sequence={{
                  id: this.model.id,
                  name: this.model.name(),
                  activeVersionId: this.model.getActiveVersionId(),
                  folderId: getInitialFolderIdForDuplicate(this.model),
                }}
              />
            );
          }}
          openHRTemplate={() => {
            let existingHRTemplateTab;
            this.closePanel();
            // eslint-disable-next-line no-cond-assign
            if ((existingHRTemplateTab = this._findExistingHRTemplateTab()) != null) {
              existingHRTemplateTab.set({active: true});
            } else {
              // Open a tab with the given HRTemplateInformation
              const sequenceFile = this.model.fileState();
              sequenceFile.buffers().addTab(new HRTemplateTabState({sequence: this.model}));
            }
          }}
        />
      ),
    },
  ];

  override closePanel = (): void => {
    this.panelState.trigger('close');
  };

  openAnalysis = (analysisId: string): void => {
    const sequenceFile = this.model.fileState() as SequenceFileState;
    const existingTab = this._findExistingTab(analysisId, sequenceFile);
    if (existingTab != null) {
      existingTab.set({active: true});
    } else {
      sequenceFile.buffers().addTab(new CRISPRAnalysisTabState({analysisId, sequence: this.model}));
    }
    this.panelState.trigger('close');
  };

  closeAnalysis = (analysisId: string): void => {
    const sequenceFile = this.model.fileState() as SequenceFileState;
    const existingTab = this._findExistingTab(analysisId, sequenceFile);
    if (existingTab != null) {
      existingTab.close();
    }
  };

  _findExistingTab(analysisId: string, sequenceFile: SequenceFileState): CRISPRAnalysisTabState | null {
    return sequenceFile.findTab(
      CRISPRAnalysisTabState,
      (tab: CRISPRAnalysisTabState) => tab.analysisId() === analysisId
    );
  }

  _findExistingHRTemplateTab(): HRTemplateTabState | null {
    return this.model
      .fileState()
      .findTab(HRTemplateTabState, (tab: HRTemplateTabState) => tab.sequence().id === this.model.id);
  }
}

export default GenomeEngineeringPanelView;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function __guard__(value: any, transform: any): any {
  return value != null ? transform(value) : undefined;
}
